import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import AlertMessageList from '../../views/Contact/AlertMessageList';
import { ISSUES } from '../../../constants/issues';
import { useAlertMessageMobileStyles } from './styles';

const AlertMessageMobile = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const issueId = params.get('issueId');
  const motiveId = params.get('motiveId');

  const issue = ISSUES.find((i) => i.id === issueId);
  const motive = issue.motives.find((m) => m.id === motiveId);

  const classes = useAlertMessageMobileStyles();

  return (
    <React.Fragment>
      <Box className={classes.container}>
        <img className={classes.icon} src={issue.icon} alt="" />
        <Typography className={classes.title}>{issue.title} </Typography>
      </Box>
      <Box className={classes.container}>
        <Typography marginTop="10px" className={classes.subtitle}>
          {motive.title}{' '}
        </Typography>
      </Box>
      <AlertMessageList mobile motiveId={motiveId} />
    </React.Fragment>
  );
};

export default AlertMessageMobile;
